<div class="wrapper" [ngClass]="contentPosition">
  <div class="saved-prompts" *ngIf="savedPrompts; else chatWrapper">
    <app-saved-prompts
      (promptSelectEvent)="promptSelected($event)"
      (backToChatEvent)="showChat()"/>
  </div>
</div>
<ng-template #chatWrapper>
  <app-prompt-settings-new (savedPromptsSelectedEvent)="showSavedPrompts()" [settings]="promptSettings"/>
  <app-reference-drawer *featureFlag="'referencesRevamp'" />
  <ng-content></ng-content>
  <div id="xls-not-supported-notification" *ngIf="showXLSUnsupportedNotification">
    <app-notification-card
      label="Gene.AI no longer supports the .xls file type. "
      message="Please save your files as .xlsx and re-upload to continue."
      type="warning"
      color="#E71316"
    />
  </div>

  <prompt-input-preview-images *featureFlag="'copyPasteImages'" [pastedImage]="pastedImage"/>
  <app-image-manager [showImageManager]="showImageManager"/>

  <ng-content select=".missing-files-notification"></ng-content>
  <prompt-input-new
    [promptSettings]="promptSettings"
    [isStreamingResponse]="isStreamingResponse"
    [config]="promptInputConfig"
    (promptSubmit)="promptSubmit.emit($event)"
    (promptSettingsClick)="openPromptSettings()"
    (stopStreaming)="stopStreaming.emit($event)"
    (unsupportedFileFound)="handleUnsupportedFileEvent($event)"
    [agent]="agent"
    [ratingEnabled]="ratingEnabled"
    (agentRated)="agentRatedEvent($event)"
    (pastedImage)="handleImagePasteConfirmationModal($event)"
  />
</ng-template>

<gene-modal [id]="'image-paste-confirmation-modal'" [headline]="'Replace file?'"
           *featureFlag="'copyPasteImagesConfirmation'">
  <p class="confirm-text">
    You can only select one type of file at a time. This will discard you current selected file(s).
    Are you sure you want to continue?<br>
    Any uploads will remain in your document library.
  </p>
  <div class="action-controls">
    <core-button label="Cancel" type="button" variant="information" size="regular" noradius="none" arialabel="Cancel"
                 (click)="closeImagePasteConfirmationModal()"/>
    <core-button label="Continue" type="button" variant="primary" size="regular" noradius="none" arialabel="Continue"
                 (click)="handlePastedImage()"/>
  </div>
</gene-modal>
